import { updateRecordInStore, deleteRecordInStore } from 'utils/redux';
import {
  CREATE_MESSAGE_PENDING,
  CREATE_MESSAGE_FAIL,
  CREATE_MESSAGE_SUCCESS,
  GET_MESSAGES_PENDING,
  GET_MESSAGES_FAIL,
  GET_MESSAGES_SUCCESS,
  GET_MESSAGE,
  RESET_MESSAGE,
  GET_MESSAGE_FILES,
  UPDATE_MESSAGE,
  TOGGLE_INBOX_DETAIL,
  DESTROY_MESSAGE,
  GET_MESSAGE_FULL_THREAD,
  GET_FULL_MESSAGE,
  SET_AUTO_CATEGORIZED_DATE_MESSAGE,
} from 'redux/actions/messageActions';
import { UPDATE_OPPORTUNITY } from 'redux/actions/opportunityActions';
import {
  UPDATE_OUTREACH_STATUS,
  UPDATE_OUTREACH_STATUS_BULK,
} from 'redux/actions/outreachActions';


const initialState = {
  message: {
    loading: true,
    loaded: false,
    id: null,
    imap_message_id: null,
    imap_uid: null,
    sent_from_email: '',
    sent_from_name: '',
    email_service_provider_config: null,
    is_read: false,
    subject: '',
    body_html: null,
    body_plain: null,
    received_date: null,
    headers: null,
    created_date: null,
    isOpen: false,
    sent_to: [],
    cc: [],
    files: null,
    is_truncated: false,
  },
  messages: {
    loading: true,
    loaded: false,
    count: null,
    next: null,
    previous: null,
    results: [],
    files: null,
  },
};

export const messageReducer = (state = initialState.message, action) => {
  switch (action.type) {
    case TOGGLE_INBOX_DETAIL:
      return {
        ...state,
        isOpen: !state.isOpen,
      };
    case CREATE_MESSAGE_PENDING:
      return {
        ...state,
        loading: true,
        loaded: false,
      };
    case CREATE_MESSAGE_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        ...action.payload,
      };
    case CREATE_MESSAGE_FAIL:
      return {
        ...state,
        loading: false,
        loaded: true,
        ...action.payload,
      };
    case GET_MESSAGE.pending:
      return {
        ...state,
        loading: true,
        loaded: false,
      };
    case GET_MESSAGE.success:
      return {
        ...state,
        loading: false,
        loaded: true,
        ...action.payload.data,
      };
    case GET_MESSAGE.name:
      return {
        ...state,
        loading: false,
        loaded: true,
        ...action.payload,
      };
    case GET_MESSAGE.error:
      return {
        ...state,
        loading: false,
        loaded: true,
        ...action.payload.data,
      };
    case RESET_MESSAGE:
      return {
        ...initialState.message,
      };
    case GET_FULL_MESSAGE.pending:
      if (state.id === action.meta.messageId) {
        // check if expanding parent message.
        return {
          ...state,
          loadingSubMessage: true,
        };
      }
      return {
        ...state,
        messages: updateRecordInStore(
          r => r.id === action.meta.messageId,
          state.messages,
          {
            ...state.messages.find(m => m.id === action.meta.messageId),
            loadingSubMessage: true,
          },
        ),
      };
    case GET_FULL_MESSAGE.success:
      if (state.id === action.payload.data.id) {
        return {
          ...state,
          loadingSubMessage: false,
          ...action.payload.data,
        };
      }
      return {
        ...state,
        loadingSubMessage: false,
        messages: updateRecordInStore(
          r => r.id === action.payload.data.id,
          state.messages,
          { ...action.payload.data, loadingSubMessage: false },
        ),
      };
    case GET_FULL_MESSAGE.name:
      return {
        ...state,
        loadingSubMessage: false,
        loaded: true,
        ...action.payload,
      };
    case GET_FULL_MESSAGE.error:
      return {
        ...state,
        ...action.payload.data,
      };
    case UPDATE_OUTREACH_STATUS:
      if (state.outreach === action.payload.id) {
        return {
          ...state,
          loading: false,
          loaded: true,
          reply_status: action.payload.newStatus.code,
          auto_categorized_date: null,
        };
      }
      return state;
    case SET_AUTO_CATEGORIZED_DATE_MESSAGE:
      if (state.id === action.payload.messageId) {
        return {
          ...state,
          loading: false,
          loaded: true,
          auto_categorized_date: action.payload.autoCategorizedDate,
        };
      }
      return state;
    case GET_MESSAGE_FILES.pending:
      return {
        ...state,
        loading: true,
        loaded: false,
      };
    case GET_MESSAGE_FILES.success:
      if (state.id === action.payload.data.id) {
        return {
          ...state,
          loading: false,
          loaded: true,
          files: action.payload.data.files,
        };
      }
      return {
        ...state,
        loading: false,
        loaded: true,
      };
    case GET_MESSAGE_FULL_THREAD.pending:
      return {
        ...state,
        loading: true,
        loaded: false,
        isOpen: true,
      };
    case GET_MESSAGE_FULL_THREAD.success:
      return {
        ...state,
        loading: false,
        loaded: true,
        isOpen: true,
        ...action.payload.data,
      };
    case GET_MESSAGE_FULL_THREAD.name:
      return {
        ...state,
        loading: false,
        loaded: true,
        ...action.payload,
      };
    case GET_MESSAGE_FULL_THREAD.error:
      return {
        ...state,
        loading: false,
        loaded: true,
        ...action.payload.data,
      };
    case UPDATE_OPPORTUNITY.success:
      return {
        ...state,
        opportunity: action.payload.data,
      };
    case UPDATE_MESSAGE.success:
      return {
        ...state,
        opportunity: action.payload.data.opportunity,
      };
    default:
      return state;
  }
};

export const messagesReducer = (state = initialState.messages, action) => {
  switch (action.type) {
    case UPDATE_MESSAGE.success:
      return {
        ...state,
        loading: false,
        loaded: true,
        results: updateRecordInStore(
          r => r.id === action.payload.data.id,
          state.results,
          action.payload.data,
        ),
      };
    case GET_MESSAGE.success:
      return {
        ...state,
        results: updateRecordInStore(
          r => r.id === action.payload.data.id,
          state.results,
          action.payload.data,
        ),
      };
    case GET_MESSAGES_PENDING:
      return {
        ...state,
        loading: true,
        loaded: false,
        ...action.payload,
      };
    case GET_MESSAGES_SUCCESS:
      return {
        loading: false,
        loaded: true,
        ...action.payload,
      };
    case GET_MESSAGES_FAIL:
      return {
        loading: false,
        loaded: true,
        ...action.payload,
      };
    case DESTROY_MESSAGE.pending:
      return {
        ...state,
        loading: true,
        loaded: false,
      };
    case DESTROY_MESSAGE.success:
      /* eslint-disable-next-line no-case-declarations */
      const messageId = action.payload.request.responseURL.split('/').slice(-2)[0];
      return {
        ...state,
        loading: false,
        loaded: true,
        results: deleteRecordInStore(
          r => r.id !== messageId,
          state.results,
        ),
      };
    case UPDATE_OUTREACH_STATUS:
      return {
        ...state,
        loading: false,
        loaded: true,
        results: updateRecordInStore(
          r => r.outreach === action.payload.id,
          state.results,
          { reply_status: action.payload.newStatus.code },
        ),
      };
    case UPDATE_OUTREACH_STATUS_BULK:
      return {
        ...state,
        loading: false,
        loaded: true,
        results: updateRecordInStore(
          r => action.payload.ids.includes(r.outreach),
          state.results,
          {
            reply_status: action.payload.newStatus.code,
            auto_categorized_date: null,
          },
        ),
      };
    case SET_AUTO_CATEGORIZED_DATE_MESSAGE:
      return {
        ...state,
        loading: false,
        loaded: true,
        results: updateRecordInStore(
          r => r.id === action.payload.messageId,
          state.results,
          { auto_categorized_date: action.payload.autoCategorizedDate },
        ),
      };
    case GET_MESSAGE_FILES.success:
      // eslint-disable-next-line no-case-declarations
      const messages = state.results;
      action.payload.data.forEach((idWithFiles) => {
        messages.forEach((message) => {
          if (message.id === idWithFiles.id) {
            // eslint-disable-next-line no-param-reassign
            message.files = idWithFiles.files;
          }
          if (!message.messages) return;
          message.messages.forEach((subMessage) => {
            if (subMessage.id === idWithFiles.id) {
              // eslint-disable-next-line no-param-reassign
              subMessage.files = idWithFiles.files;
            }
          });
        });
      });

      return {
        ...state,
        loading: false,
        loaded: true,
        results: messages,
      };
    case GET_MESSAGE_FILES.error:
      return {
        ...state,
        loading: false,
        loaded: true,
      };
    default:
      return state;
  }
};
